
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/translations";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQAccordion = () => {
  const { language } = useLanguage();
  const t = translations[language].summerCamp.faq;

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h3 className="text-2xl font-semibold text-primary mb-6">{t.title}</h3>
      <Accordion type="single" collapsible className="w-full">
        {t.questions.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger>{item.question}</AccordionTrigger>
            <AccordionContent>
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQAccordion;
